<template>
  <PortableText
    v-if="title?.standardPortableText"
    :portable-data="title.standardPortableText"
    :class="{
      'mb-8 text-www-color-neutral-medium-dark': true,
    }"
  />
  <div
    :class="{
      'grid grid-cols-12 gap-6': true,
    }"
  >
    <DesignerCardComponent
      v-for="(card, index) in cards"
      :key="index"
      v-bind="card"
      :class="{
        'col-span-12 h-full md:col-span-6 lg:col-span-3': true,
      }"
    />
  </div>
  <ButtonRow
    v-if="ctaButtons"
    v-bind="ctaButtons"
    :class="{
      'mt-10 text-center md:mt-100px': true,
    }"
  />
</template>

<script lang="ts" setup>
import ButtonRow from '~/components/Atoms/ButtonRow/ButtonRow.vue';
import DesignerCardComponent from './DesignerCard.vue';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import type { DesignerCard } from '~/sanity/types';
defineProps<DesignerCard>();
</script>
<style></style>
